import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_novelty,
    CREATE_NOVELTY, createNovelty,
    getAllNovelty,
    get_report,
    GET_REPORT
} from '../../../redux/novelty';
import Select from "react-select";
import {primarySelectTheme, primarySelectStyles} from "../../../config";
import LoadingSpinner from "../../../components/loading-spinner";
// import {get_all_establishments} from "../../../redux/establishment";
import {getAllOperator} from "../../../redux/operator";
import {getAllTypeNovelty} from "../../../redux/type_novelty";


const NovedadesAdmin = (props) => {
    const dispatch = useDispatch();

    /* Usando el gancho useSelector para obtener el estado del módulo de noveltyas. */
    const _get_all_novelty = useSelector((state) => state.novelty_module._get_all_novelty);

    const _get_all_operator = useSelector((state) => state.operator_module._get_all_operator);
    const _get_all_type_novelty = useSelector((state) => state.type_novelty_module._get_all_type_novelty);

    const _create_novelty = useSelector((state) => state.novelty_module._create_novelty);

    const _get_report = useSelector((store) => store.novelty_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _session_data = useSelector((state) => state.users_module._session_data);

    useEffect(() => {
        dispatch(getAllNovelty(token));
        // dispatch(get_all_establishments(token));
        dispatch(getAllOperator(token));
        dispatch(getAllTypeNovelty(token));
        // eslint-disable-next-line
    }, [token, dispatch]);


    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [costCenter, setCostCenter] = useState([]);
    const [operator, setOperator] = useState([]);
    const [typeNovelty, setTypeNovelty] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (_session_data.data) {
            let costs = [];
            if (_session_data.data.centros_costos) {
                costs = _session_data.data.centros_costos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre
                    }
                })
            }
            setCostCenter(costs);
        }
    }, [_session_data]);

    useEffect(() => {
        if (_get_all_operator && _get_all_operator.data && _get_all_operator.data.datos) {
            // eslint-disable-next-line
            let array = _get_all_operator.data.datos.map(element => {
                if (element.activo === true) {
                    return {
                        value: element.id,
                        label: element.nombre
                    }
                }
            })
            setOperator(array);
        }
    }, [_get_all_operator]);

    useEffect(() => {
        if (_get_all_type_novelty && _get_all_type_novelty.data && _get_all_type_novelty.data.datos) {
            // eslint-disable-next-line
            let array = _get_all_type_novelty.data.datos.map(element => {
                if (element.activo === true) {
                    return {
                        value: element.id,
                        label: element.descripcion
                    }
                }
            })
            setTypeNovelty(array);
        }
    }, [_get_all_type_novelty]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Tipo de novedad', id: 2},
        {name: 'Operario', id: 3},
        {name: 'Centro de costo', id: 4},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_cost_center: false,
        id_cost_center: 0,
        visible_type_novelty: false,
        id_type_novelty: 0,
        visible_operator: false,
        id_operator: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_centro_costo: 0,
        centro_costo: "",
        id_tipo_novedad: 0,
        tipo_novedad: "",
        id_operario: 0,
        operario: "",
        comentario: "",
        fecha_novedad: "",
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_novelty.status === 201) {
            toast.success("Novedad creada correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_novelty(CREATE_NOVELTY));
            dispatch(getAllNovelty(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_novelty.status !== 0) {
            toast.error(_create_novelty.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_novelty(CREATE_NOVELTY));
            setIsLoading(false);
        }
    }, [_create_novelty, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_novelty && _get_all_novelty.data && _get_all_novelty.data.datos) {
            setDatas(_get_all_novelty.data.datos);
        }

    }, [_get_all_novelty, count, props]);

    const loadFunc = () => {
        if (_get_all_novelty.data.datos) {
            if (_get_all_novelty.data.datos.length > count) {
                const ordenado = _get_all_novelty.data.datos.sort((a, b) => {
                    return new Date(b.fecha_novedad + ' 00:00:00') - new Date(a.fecha_novedad + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        if (e.target.value === "0") {
            setDatas(_get_all_novelty.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_cost_center: false,
                id_cost_center: 0,
                visible_type_novelty: false,
                id_type_novelty: 0,
                visible_operator: false,
                id_operator: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2' || e.target.value === '3' || e.target.value === '4') {
            if (e.target.value === '2') {
                setOtherFilter({
                    visible_cost_center: false,
                    id_cost_center: 0,
                    visible_type_novelty: true,
                    id_type_novelty: 0,
                    visible_operator: false,
                    id_operator: 0,
                });
            }
            if (e.target.value === '3') {
                setOtherFilter({
                    visible_cost_center: false,
                    id_cost_center: 0,
                    visible_type_novelty: false,
                    id_type_novelty: 0,
                    visible_operator: true,
                    id_operator: 0,
                });
            }
            if (e.target.value === '4') {
                setOtherFilter({
                    visible_cost_center: true,
                    id_cost_center: 0,
                    visible_type_novelty: false,
                    id_type_novelty: 0,
                    visible_operator: false,
                    id_operator: 0,
                });
            }
        } else {
            setOtherFilter({
                visible_cost_center: false,
                id_cost_center: 0,
                visible_type_novelty: false,
                id_type_novelty: 0,
                visible_operator: false,
                id_operator: 0,
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "id_centro_costo" || e.target.name === "id_tipo_novedad" || e.target.name === "id_operario") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const [cost_center_select, setCostCenterSelect] = useState([]);

    const handleChangeCostCenter = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_centro_costo']: parseInt(e.value),
            // eslint-disable-next-line
            ['centro_costo']: parseInt(e.label),
        });
        setCostCenterSelect(e);
    }

    const [operator_select, setOperatorSelect] = useState([]);

    const handleChangeOperator = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_operario']: parseInt(e.value),
            // eslint-disable-next-line
            ['operario']: parseInt(e.label),
        });
        setOperatorSelect(e);
    }

    const [type_novelty_select, setTypeNoveltySelect] = useState([]);

    const handleChangeTypeNovelty = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_tipo_novedad']: parseInt(e.value),
            // eslint-disable-next-line
            ['tipo_novedad']: parseInt(e.label),
        });
        setTypeNoveltySelect(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.id_centro_costo === 0) {
            toast.error("Debe seleccionar el centro de costo");
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_novedad === 0) {
            toast.error("Debe seleccionar el tipo de la novedad");
            setIsLoading(false);
            return;
        }
        if (form.id_operario === 0) {
            toast.error("Debe seleccionar el operario");
            setIsLoading(false);
            return;
        }
        if (form.fecha_novedad === "") {
            toast.error("Debe seleccionar la fecha de la novedad");
            setIsLoading(false);
            return;
        }
        if (form.comentario === "") {
            toast.error("Debe ingresar un comentario");
            setIsLoading(false);
            return;
        }
        dispatch(createNovelty(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_novelty.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_novelty.data.datos.filter(element => {
            if (element.centro_costo.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_novelty.data.datos.filter(x => {
                    if (x.fecha_novedad) {
                        let fecha = new Date(x.fecha_novedad);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_novelty(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_novelty(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_centro_costo': other_filter.id_cost_center,
            'id_operario': other_filter.id_operator,
            'id_tipo_novedad': other_filter.id_type_novelty,
        }, token));

    }

    const handleChangeFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            [e.target.name]: parseInt(e.target.value),
        });
        if (e.target.value === "0") {
            setDatas(_get_all_novelty.data.datos);
        } else {
            if (e.target.name === 'id_centro_costo') {
                let va = _get_all_novelty.data.datos.filter(x => parseInt(x.id_centro_costo) === parseInt(e.target.value));
                setDatas(va);
            }
            if (e.target.name === 'id_tipo_novedad') {
                let va = _get_all_novelty.data.datos.filter(x => parseInt(x.id_tipo_novedad) === parseInt(e.target.value));
                setDatas(va);
            }
            if (e.target.name === 'id_operario') {
                let va = _get_all_novelty.data.datos.filter(x => parseInt(x.id_operario) === parseInt(e.target.value));
                setDatas(va);
            }
        }
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Novedades"
                            items={[{label: "Listado novedade", link: "/novedades"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">

                    <div className="content-area-wrapper" style={{margin: 0}}>


                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_novelty").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setShowOverlay(!showSibarRight);
                                                        setCostCenterSelect([]);
                                                        setOperatorSelect([]);
                                                        setTypeNoveltySelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-noveltya"
                                                    name="filtro-noveltya"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_type_novelty && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Tipo de novedad</label>
                                                                <SelectInput
                                                                    label="Tipo de novedad"
                                                                    name="id_tipo_novedad"
                                                                    options={typeNovelty.map((i) => ({
                                                                        name: i.label,
                                                                        id: i.value,
                                                                    }))}
                                                                    onChange={handleChangeFilter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_operator && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Tipo de novedad</label>
                                                                <SelectInput
                                                                    label="Operario"
                                                                    name="id_operario"
                                                                    options={operator.map((i) => ({
                                                                        name: i.label,
                                                                        id: i.value,
                                                                    }))}
                                                                    onChange={handleChangeFilter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_cost_center && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Centro de costo</label>
                                                                <SelectInput
                                                                    label="Centro de costo"
                                                                    name="id_centro_costo"
                                                                    options={costCenter.map((i) => ({
                                                                        name: i.label,
                                                                        id: i.value,
                                                                    }))}
                                                                    onChange={handleChangeFilter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {

                                    permisos.filter(element => element.codigo === "add_novelty").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="noveltya">
                                                        Nueva Novedad
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Centro de costo</label>
                                                            <Select
                                                                theme={primarySelectTheme} styles={primarySelectStyles}
                                                                options={costCenter}
                                                                isMulti={false}
                                                                onChange={handleChangeCostCenter}
                                                                value={cost_center_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Tipo de novedad</label>
                                                            <Select
                                                                theme={primarySelectTheme} styles={primarySelectStyles}
                                                                options={typeNovelty}
                                                                isMulti={false}
                                                                onChange={handleChangeTypeNovelty}
                                                                value={type_novelty_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Operario</label>
                                                            <Select
                                                                theme={primarySelectTheme} styles={primarySelectStyles}
                                                                options={operator}
                                                                isMulti={false}
                                                                onChange={handleChangeOperator}
                                                                value={operator_select}
                                                            />
                                                            <br/>
                                                            <Input
                                                                 type="datetime-local"
                                                                name="fecha_novedad"
                                                                id="fecha_novedad"
                                                                label="Fecha"
                                                                onChange={handleChange}
                                                                placeholder=""
                                                                value={form.fecha_novedad}
                                                            />
                                                            <TextArea
                                                                id="comentario"
                                                                name="comentario"
                                                                label="Comentario"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.comentario}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR NOVELTYA
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por centro_costo"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                <div className="col-2">
                                                                    <Button
                                                                        text={<h3><i
                                                                            className="text-white bx bx-export"/></h3>}
                                                                        theme="success"
                                                                        type="button"
                                                                        classes="btn-lg round"
                                                                        onClick={handleGenerateReport}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.comentario}
                                                                    subtitle={item.centro_costo}
                                                                    rightDescription={'Tipo: ' + item.tipo_novedad}
                                                                    bulletType={"success"}
                                                                    children={
                                                                        <div className="user-details div_fecha">
                                                                            <div className="mail-items">
                                                                                <span>Fecha: </span>{item.fecha_novedad}
                                                                            </div>
                                                                            <div className="mail-items">
                                                                                <span>Operario: </span>{item.operario}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}

                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {/*{DataSelected.titulo}*/}
                                                    </h5>
                                                </div>
                                                {/*<div className="email-header-right mb-1 ml-2 pl-1">*/}
                                                {/*    <span*/}
                                                {/*        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>*/}
                                                {/*        {DataSelected.estado}*/}
                                                {/*    </span>*/}
                                                {/*</div>*/}
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">

                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovedadesAdmin;
